import React from 'react';

/** Libby theme palette — pink, orange, purple, teal, gold */
const SPARKLE_COLORS = [
  '#f25a94',
  '#ffb24a',
  '#d964e6',
  '#3ecfc4',
  '#ffd93d',
  '#e8a5f5',
  '#d9468f',
  '#2fb0a6',
];

const SPARKLE_KINDS = ['dot', 'star', 'star2', 'burst', 'ring', 'plus'];

/** ~100 page sparkles (original was ~242). */
const PAGE_SPARKLE_COUNT = 100;

function sparkleColor(i, item) {
  return SPARKLE_COLORS[(i * 7 + item.l + item.t) % SPARKLE_COLORS.length];
}

/**
 * Procedural sparkles spread across a full-width band.
 * When `sparseTextZone` is set, fewer particles land in the bottom-left copy area.
 */
function buildScatteredSparkles(count, seed = 0, { sparseTextZone = false } = {}) {
  const out = [];
  for (let i = 0; i < count; i++) {
    const n = seed + i;
    const kind = SPARKLE_KINDS[n % SPARKLE_KINDS.length];
    let l = ((n * 17 + 13) % 98) + 1;
    let t = ((n * 23 + 7) % 97) + 1;

    if (sparseTextZone) {
      const inCopyZone = l < 56 && t > 50;
      if (inCopyZone && n % 4 !== 0) {
        l = ((n * 29 + 41) % 38) + 58;
        t = ((n * 13 + 19) % 42) + 8;
      }
    }

    out.push({
      l,
      t,
      delay: (n % 10) * 0.1 + (n % 3) * 0.06,
      dur: 2.6 + (n % 5) * 0.4,
      kind,
      ...(kind === 'dot' ? { s: 2 + (n % 3) } : {}),
    });
  }
  return out;
}

const SPARKLE_PAGE = buildScatteredSparkles(PAGE_SPARKLE_COUNT, 200);

const GLYPH = { star: '✦', star2: '✧', burst: '★', plus: null, dot: null, ring: null };

function renderSparkleItem(item, i, keyPrefix) {
  const style = {
    left: `${item.l}%`,
    top: `${item.t}%`,
    animationDelay: `${item.delay}s`,
    animationDuration: `${item.dur}s`,
    '--sparkle-color': sparkleColor(i, item),
  };
  const k = `${keyPrefix}-${i}`;
  if (item.kind === 'dot') {
    return <span key={k} className="sparkle-fx__dot" style={{ ...style, width: item.s, height: item.s }} />;
  }
  if (item.kind === 'ring') {
    return <span key={k} className="sparkle-fx__ring" style={style} />;
  }
  if (item.kind === 'plus') {
    return <span key={k} className="sparkle-fx__plus" style={style} />;
  }
  const g = GLYPH[item.kind];
  return (
    <span key={k} className="sparkle-fx__glyph" style={style}>
      {g}
    </span>
  );
}

/** Main-content background sparkles — scoped to `.v2-main`, not the hero. */
export function PageSparkleLayer() {
  return (
    <div className="sparkle-fx sparkle-fx--page" aria-hidden>
      {SPARKLE_PAGE.map((item, i) => renderSparkleItem(item, i, 'pg'))}
    </div>
  );
}

